module.exports = __webpack_public_path__ + "static/media/gvd_icon.a8eb862d.svg";